import React from "react";
import { Loader2 } from "lucide-react";
import "./MobileBottomBar.css";

const MobileBottomBar = ({
  onNext,
  isNextEnabled = true,
  isLoading = false,
  nextText = "NEXT",
  nextIconSrc,
  showSkip = false,
  isSkipBlue = false,
  onSkip,
  skipText = "SKIP",
  variant = "default",
  className = "",
}) => {
  const isDisabled = !isNextEnabled || isLoading;

  return (
    <div className={`common-bottom-bar mobile-only ${className}`}>
      {showSkip ? (
        <button
          className="common-skip-btn"
          onClick={onSkip}
          disabled={isLoading}
          style={{ color: isSkipBlue ? "#009fd9" : "" }}
        >
          {skipText}
        </button>
      ) : (
        <div className="common-spacer"></div>
      )}

      <div
        className={`common-next-wrapper ${isNextEnabled && !isLoading ? "enabled" : "disabled"}`}
        onClick={!isDisabled ? onNext : undefined}
      >
        <button
          className={`common-next-btn variant-${variant}`}
          disabled={isDisabled}
        >
          <span className="common-next-text">
            {isLoading ? (
              <>
                <Loader2
                  className="animate-spin"
                  size={20}
                  style={{ marginRight: "8px", marginBottom: "-4px" }}
                />
                WAIT...
              </>
            ) : (
              nextText
            )}
          </span>

          <div className="common-next-icon-circle">
            {nextIconSrc && (
              <img src={nextIconSrc} alt="Next" className="common-next-img" />
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

export default MobileBottomBar;
